import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Header from './Header'
import Error from '@components/Error/NoContent'
import Spinner from '@components/spinner'
import Pagination from '@components/Pagination'
import Actions from './Actions'
import ResultsTable from './ResultsTable'
import Scroll from '@components/Scroll'
import PropTypes from 'prop-types'

class SearchResults extends Component {
  componentDidMount () {
    this.loadContracts()
  }

  loadContracts () {
    const { contractSearchStore } = this.props
    contractSearchStore.filter()
  }

  render () {
    const { contractSearchStore } = this.props
    const { contractsCount, contracts, loading, query } = contractSearchStore

    if (loading) {
      return <Spinner />
    }

    return (
      <div className='expert-search-results'>
        <Scroll>
          <div className='project-wrapper'>
            <Header contractsCount={contractsCount} />
            <Actions contractSearchStore={contractSearchStore} />
            {contracts && contractsCount ? (
              <ResultsTable contracts={contracts} />
            ) : (
              <Error
                label={'No contracts match the current search parameters'}
              />
            )}
            <Pagination
              total={contractsCount}
              perPage={query.limit}
              page={query.page}
              onChange={p => contractSearchStore.changePage(p)}
            />
          </div>
        </Scroll>
      </div>
    )
  }

  static propTypes = {
    contractSearchStore: PropTypes.object
  }
}

export default observer(SearchResults)
